export default __webpack_public_path__ + "static/media/facebook.e6776da7.svg";